import {Box} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';

const SingleUpdateHistoryBlockContainer = muiStyled(Box)(({theme}) => ({
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(2),
  overflow: 'hidden'
}));

export default SingleUpdateHistoryBlockContainer;
